// src/components/Header/Header.js
import logoDev4u from "../../assets/logoDev4u.png";
import "./Header.scss";
import { NavLink } from "react-router-dom";
import { useState } from "react";

function Header() {
  const [isClicked, setIsClicked] = useState(false);

  const handleLinkClick = () => {
    setIsClicked(false);
  };

  const toggleMenu = () => {
    setIsClicked((prev) => !prev);
  };

  return (
    <header className="vs-header">
      <div className="container vs-header__inner">
        <div className="logo-container">
          <NavLink to="/" onClick={handleLinkClick}>
            <img
              src={logoDev4u}
              alt="Logo Dev4U"
              className="header-logo"
            />
          </NavLink>
        </div>

        <button
          type="button"
          className="hamburger"
          onClick={toggleMenu}
          aria-label="Ouvrir ou fermer le menu"
        >
          ☰
        </button>

        <nav className={`header-nav ${isClicked ? "open" : ""}`}>
          <ul>
            <li>
              <NavLink to="/" className="nav-link" onClick={handleLinkClick}>
                Accueil
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/Projets"
                className="nav-link"
                onClick={handleLinkClick}
              >
                Projets
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/APropos"
                className="nav-link"
                onClick={handleLinkClick}
              >
                Qui je suis
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/Contact"
                className="nav-link"
                onClick={handleLinkClick}
              >
                Contact
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
